export enum CARD_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  CLOSED = 'closed',
  FROZEN = 'frozen',
}

export enum CARD_TYPE {
  PHYSICAL = 'physical',
  VIRTUAL = 'virtual',
}

export enum CARD_REPLACEMENT_REASON {
  LOST = 'lost',
  STOLEN = 'stolen',
  DAMAGED = 'damaged',
}

export enum CARD_ISSUER_TYPE {
  FSA_DEBIT = 'fsaDebit',
  BUSINESS_DEBIT = 'businessDebit',
}

export enum CARD_HOLDER_TYPE {
  MEMBER = 'member',
  DEPENDENT = 'dependent',
}

export enum COUNTRY_CODE {
  US = '1',
}

export enum CARD_TAB_NAME {
  FORMA_CARD = 'Forma Card',
  BENEFITS_CARD = 'Benefits Card',
  WCS_HSA_CARD = 'WCS HSA Card',
}
